import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withJsScript from 'client/helpers/withJsScript';

@withJsScript({
  scriptUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/4.13.0/bodymovin_light.js',
})
class SrAgentLeadHighFiveModal extends Component {
  static propTypes = {
    isJsScriptLoaded: PropTypes.bool.isRequired,
    appUrl: PropTypes.string.isRequired,
  };

  constructor() {
    super();
    this.el = null;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.isJsScriptLoaded && nextProps.isJsScriptLoaded) {
      this._showAnimation();
    }
  }

  _showAnimation = () => {
    if (global.bodymovin) {
      const { appUrl } = this.props;
      global.bodymovin.loadAnimation({
        container: this.el,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: `${appUrl}/high-five-animation.json`,
      });
    }
  };

  render() {
    return (
      <div
        className='svgAnimation'
        ref={(el) => {
          this.el = el;
        }}
      />
    );
  }
}

SrAgentLeadHighFiveModal.displayName = 'SrAgentLeadHighFiveModal';

export default SrAgentLeadHighFiveModal;
